import { render, staticRenderFns } from "./HospitalizationInputForm.vue?vue&type=template&id=feb2e510&scoped=true&"
import script from "./HospitalizationInputForm.vue?vue&type=script&lang=js&"
export * from "./HospitalizationInputForm.vue?vue&type=script&lang=js&"
import style0 from "./HospitalizationInputForm.vue?vue&type=style&index=0&id=feb2e510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb2e510",
  null
  
)

export default component.exports